import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const statuses = ['publish', 'draft', 'private'];
const config = (): AxiosRequestConfig => {
  let headers: any = {
    ['content-type']: 'application/json',
  };
  if (window.NONCE && window.NONCE.indexOf('<?php') < 0) {
    headers['X-WP-Nonce'] = window.NONCE;
  }
  return {
    headers: headers,
  };
};

export const fetch = (endpoint: string) => {
  const forSinglePage = endpoint.indexOf('/works/') >= 0;
  // ACF Options は単一オブジェクトを返し ?status= を持たないため、
  // multi-status 並列フェッチに乗せると flatMap で構造が崩れる。単発 GET に振り分ける。
  const isAcfOptions = endpoint.indexOf('/acf/') >= 0;

  //ゲストユーザーまたはシングルページの読み込み / ACF Options
  if (!window.NONCE || forSinglePage || isAcfOptions || window.NONCE.indexOf('<?php') >= 0) {
    return axios.get(process.env.REACT_APP_API_URL + endpoint, config());
  }

  //ログイン済みユーザーがWorks/People/Servicesにアクセス
  return (async () => {
    const all: Promise<any>[] = statuses.map((status, index) =>
      axios.get(process.env.REACT_APP_API_URL + endpoint, {
        ...config(),
        params: {
          status: status,
        },
      })
    );
    const responses = await Promise.all(all);

    return {
      data: responses.flatMap((res, index) => res.data),
    };
  })();
};

export const fetchNote = () => axios('/date.php');
